export default __webpack_public_path__ + "img/2927059958c39ed49fb21d5c8a7e3981.svg";